import type { CSSProperties } from "react";

import { Paper } from "@mantine/core";
import clsx from "clsx";

import classes from "./AppCard.module.css";

interface AppCardProps {
  title: string;
  /** The header's right-hand note: a sort order, a count. */
  aside: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  style?: CSSProperties;
}

/** A list card from the app, its header row in the app's own words. */
export default function AppCard({ title, aside, children, className, style }: AppCardProps) {
  return (
    <Paper withBorder radius={10} className={clsx(classes.card, className)} style={style}>
      <div className={classes.header}>
        <b className={classes.title}>{title}</b>
        <span className={classes.aside}>{aside}</span>
      </div>
      {children}
    </Paper>
  );
}
